<div class="pt-4 pt-md-4">
   <mnf-section-primary [totalPartsUsers]="totalPartsUsers" [infoProject]="infoProject"></mnf-section-primary>
   <div class="owl-info-father ps-9 mt-4">
      <owl-carousel-o [options]="customOptions" id="carouse-product" class="info-carousel refreshClass">
         @for (item of sectionsToShow; track item.id){
            <ng-template [width]="250" carouselSlide>
               <button class="btn-carousel fs-14 fw-sbold" [class.btn-carousel-selected]="item.isSelected" (click)="changeSection(item.id)">
                  {{ item.title }}
               </button>
            </ng-template>
         }
      </owl-carousel-o>
   </div>

   @if(this.defaultSection == 'info') {
      <mnf-section-information [infoProject]="infoProject"></mnf-section-information>
   } @else if (this.defaultSection == 'investment-opportunities') {
      <mnf-section-opportunities [infoProject]="infoProject"></mnf-section-opportunities>
   } @else if (this.defaultSection == 'simulator' && infoProject?.actualState == 'fixed') {
      <mnf-section-simulator [amountFromURL]="paramsSimulator?.amount"  [totalPerformance]="infoProject?.totalPerformance" [infoProject]="infoProject"></mnf-section-simulator>
   }

   <div class="project-footer-mobile d-block d-lg-none">
      <div class="first-part" [ngClass]="{
         'ios-footer': isIOSDevice,
         'bg-primary': infoProject?.actualState == 'fixed',
         'bg-secondary': infoProject?.actualState != 'fixed'
         }">
         <div class="col-12 d-flex align-items-center justify-content-center">
            <a (click)="next(infoProject)" *ngIf="infoProject?.phase?.free >= 1" class="btn fw-sbold">Invertir ahora</a>
            <p *ngIf="infoProject?.phase?.free <= 1" class="cl-white fw-sbold mb-0">{{ totalPartsUsers || 0 }} Inversionistas activos</p>
         </div>
      </div>
      <div class="second-part" [ngClass]="{'ios-footer' : isIOSDevice}">
         <div class="col-12 text-center">
            <p class="cl-black fw-normal mb-0 py-1 fs-13">Invierte desde <span class="cl-primary fw-sbold">$ {{ infoProject?.phase?.partValue | number }}</span></p>
         </div>
      </div>
      <div class="third-part"></div>
   </div>
</div>